import AuthenticationApi from '@/data/authentication/AuthenticationApi.ts';
import { useAccessTokenStore } from '@/stores/AccessTokenStore.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import AccessToken from '../AccessToken.ts';
import UserApi from '@/data/users/UserApi.ts';
import { useUserStore } from '@/stores/UserStore.ts';

export default class SignInService {
  private authenticationApi: AuthenticationApi;
  private userApi: UserApi;

  /**
   * Initialize and construct the {SignInService}.
   */
  constructor() {
    this.authenticationApi = new AuthenticationApi();
    this.userApi = new UserApi();
  }

  /**
   * Sign in with email and password.
   *
   * @param email The email to sign in with.
   * @param password The password to sign in with.
   * @returns {Promise} A promise containing an object of
   * {SignedIn} if successful, otherwise an emitted error.
   */
  signIn(email: string, password: string): Promise<boolean> {
    return this.authenticationApi
      .signIn({
        email: email,
        password: password,
      })
      .then((signedIn) => {
        // Store the access token.
        useAccessTokenStore().set(new AccessToken(signedIn.data.access_token));
      })
      .then(() =>
        // Now that the access token is set, we fetch the user to store it.
        this.userApi.getMe({}, ['companies']),
      )
      .then((response) => {
        // Store the fetched user.
        useUserStore().set(response.data);

        return useSessionStore().isAuthenticated();
      });
  }
}
